import { Component, OnInit } from '@angular/core';
import {gutil} from '../gutil';
import {HttpHeaders , HttpClient} from '@angular/common/http';
import {SessionService} from '../services/session.service';
import {Router, ActivatedRoute} from '@angular/router';
import {  faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.scss']
  })
export class ResetComponent implements OnInit {

    public faTimes = faTimes;
    public reset = {email: "", password: "", password_confirmation: "", token: ""};
    public show_login_fail : boolean = false;
    public field_pass : boolean = false;
    public field_fail : boolean = false;
    public show_cpassword_fail : boolean = false;
    constructor(private http: HttpClient , private router : Router, private sessionservice : SessionService, private actroute: ActivatedRoute){
        if(this.router.url.includes('/auth/reset?token') != false){
            let params = new URLSearchParams(this.decodedURL(this.router.url).split('?')[1]);
            if(params.get('token')!= null && params.get('email') != null){
                this.reset.email = params.get('email');
                this.reset.token = params.get('token');
            }
        }
    }

    ngOnInit(){
        if(this.reset.email != "" && this.reset.token != ""){
            this.resetPassword();
        }

    }
    private decodedURL(value: any){
        return decodeURIComponent(value);
    }
    // set new password
    public resetPassword(){
        
        if(this.reset.token !=""){
            console.log('1');
            if(this.reset.email != ""){
                console.log('2');
                document.getElementById('email').classList.add('pass');
                if(this.reset.password != ""){
                    console.log('3');
                    document.getElementById('password').classList.add('pass');
                    if(this.reset.password_confirmation != ""){
                        console.log('4');
                        document.getElementById('c_password').classList.add('pass');
                        if(this.reset.password === this.reset.password_confirmation){
                            console.log('5');
                            let headers = new HttpHeaders({'Content-Type' : 'application/x-www-form-urlencoded'});
                            let options = {headers : headers};
                            let params = new URLSearchParams();
                            params.append('token' , this.reset.token);
                            params.append('email' , this.reset.email);
                            params.append('password' , this.reset.password);
                            params.append('password_confirmation', this.reset.password_confirmation);

                            let paramsString = params.toString();
                            this.http.post(gutil.devapiUrl + '/api/w/v1/password/reset' , paramsString , options).subscribe((data : any) => {
                                console.log(data.messages[0].message);
                                if(data.messages[0].message === "Your password has been reset!"){
                                    this.router.navigate(['/login']);
                                }else{
                                    this.show_login_fail = true;
                                }
                            })
                        }else{
                            console.log('6');
                            this.show_cpassword_fail = true;
                        }
                    }else{
                        document.getElementById('c_password').classList.add('fail');
                    }
                }else{
                    document.getElementById('password').classList.add('fail');
                }
            }else{
                document.getElementById('email').classList.add('fail');
            }
        }
    }

    public changeResetEmail(value: any){
        if(this.reset.email != "" && this.reset.token != ""){
            this.reset.email = value;
            document.getElementById('email').classList.add('pass');
        }else{
            document.getElementById('email').classList.add('fail');
        }
    }

    public changeResetPassword(value: any){
        if(this.reset.email != "" && this.reset.token != ""){
            this.reset.password = value.trim();
            if(value != '' && value.length > 7){
                document.getElementById('password').classList.add('pass');
            }else{
                document.getElementById('password').classList.add('fail');
            }
        }
    }

    public changeResetPasswordConfirmation(value : any){
        if(this.reset.email != "" && this.reset.token != ""){
            this.reset.password_confirmation = value.trim();
        }
    }
}